import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ScimApiKey } from '../../models/domain';
import { ScimActions } from '../actions';

export interface ScimState {
  apiKeys: EntityState<ScimApiKey>;
  isLoading: boolean;
}

export const scimAdapter = createEntityAdapter<ScimApiKey>({
  selectId: (apiKey) => apiKey.key_id,
});

const adapterReducer = createReducer(
  {
    isLoading: false,
    apiKeys: scimAdapter.getInitialState()
  } as ScimState,
  on(ScimActions.Load, (state) => {
    return {
      ...state,
      isLoading: true
    };
  }),
  on(ScimActions.Loaded, (state, action) => {
    return {
      ...state,
      isLoading: false,
      apiKeys: scimAdapter.addMany(action.apiKeys, scimAdapter.removeAll(state.apiKeys))
    };
  }),
  on(ScimActions.Generated, (state, action) => {
    return {
      ...state,
      apiKeys: scimAdapter.addOne(action.apiKey, state.apiKeys)
    };
  }),
  on(ScimActions.Revoked, (state, action) => {
    return {
      ...state,
      apiKeys: scimAdapter.removeOne(action.apiKeyId, state.apiKeys),
    };
  })
);

export function scimReducer(state, action: Action): ScimState {
  return adapterReducer(state, action);
}
